import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

/**
 * Atom: PageTitle – consistent page heading across V2 flows.
 * Uses theme.typography.pageHeading (design regular).
 */
export const PageTitle = styled.h1`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.pageHeading.fontSize};
  font-weight: ${theme.typography.pageHeading.fontWeight};
  line-height: ${theme.typography.pageHeading.lineHeight};
  color: ${theme.colors.primary};
  margin: 0;
`;
